import Vue from 'vue'
import Vuetify, { VRow } from 'vuetify/lib'

Vue.use(Vuetify, {
  components: { VRow }
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#CACACA',
        secondary: '#bebebe',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#841438',
        warning: '#FFC107',
        anchor: '#00000A'
      }
    }
  }
})
